import ConfigProvider from 'antd/lib/config-provider'

export { ConfigProvider }
